import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { useMemo } from "react";

const statusColors = {
    Present: "#6BE598", // green
    Absent: "#F44336",  // red
    Leave: "#598bf7",   // orange
    Late: "#EDEF75",   // Yellow
};

const AttendanceOverview = ({ todayAttData }) => {
    // Calculate counts and percentage
    const { pieData, attendancePercentage } = useMemo(() => {
        const summary = {
            Present: 0,
            Absent: 0,
            Leave: 0,
            Late: 0
        };
        todayAttData?.forEach((record) => {
            const status = record.ATTENDANCE_STATUS;
            if (summary[status] !== undefined) {
                summary[status]++;
            }
        });

        const presentCount = summary.Present + summary.Late;
        const total = presentCount + summary.Absent;
        const percentage = total === 0 ? 0 : Math.round((presentCount / total) * 100);

        const pieData = Object.keys(summary).map((status) => ({
            name: status,
            value: summary[status],
            color: statusColors[status],
        }));
        return { pieData, attendancePercentage: percentage };
    }, [todayAttData]);
    const totalValue = pieData.reduce(
        (sum, item) => sum + (Number(item.value) || 0),
        0
    );
    return (
        <div>
            <div className="text-xl lg:text-2xl text-center font-bold ">
                {attendancePercentage}% Attendance
            </div>
            {
                totalValue === 0 ? (
                    //  Empty State
                    <div className="flex items-center justify-center h-[250px] text-gray-500 dark:text-gray-400 italic">
                        No attendance data available
                    </div>
                ) : (
                    <PieChart width={350} height={200} className="">
                        <Pie
                            data={pieData}
                            cx="50%"
                            cy="50%"
                            outerRadius={80}
                            fill="#8884d8"
                            dataKey="value"
                            label={false}
                            activeShape={{ stroke: "none" }}
                        >
                            {pieData?.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                        </Pie>
                        <Legend
                            wrapperStyle={{
                                fontSize: "12px",   //  yahan size chota karo
                                lineHeight: "14px"
                            }}
                        />
                        <Tooltip
                            cursor={{ fill: "transparent" }}
                            contentStyle={{
                                border: "none",
                                borderRadius: "6px",
                                backgroundColor: "rgba(120, 112, 60)",
                                color: "#fff",
                                padding: "4px 8px",
                                fontSize: "9px",  
                            }}
                        />
                    </PieChart>
                )
            }
        </div>
    );
};

export default AttendanceOverview;
